import React from 'react';

import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { SearchDescription, SearchTitle } from '~/components/Hero/style';
import FollowButton from '~/components/buttons/FollowButton';
import { useUserInfoContext } from '~/context/UserInfoProvider';
import useFollowExperts from '~/hooks/useFollowExperts';

export interface ExpertInfoProps {
  id?: string | null;
  name?: string | null;
  jobTitle?: string | null;
  description?: string | null;
}

const ExpertInfo: React.FC<ExpertInfoProps> = ({ id, name, jobTitle, description }) => {
  const { followed, toggleFollowing, loading: loadingToggleFollowing } = useFollowExperts([id]);
  const { userInfo } = useUserInfoContext();

  return (
    <>
      {name && (
        <TitleWrapper>
          <SearchTitle variant="h2" data-testid="expertTitle">
            {name}
          </SearchTitle>
          {!!userInfo && (
            <StyledFollowButton
              loading={loadingToggleFollowing}
              followed={followed}
              onClick={toggleFollowing}
              data-testid="followExpertBtn"
            />
          )}
        </TitleWrapper>
      )}
      {jobTitle && <SearchSubtitle data-testid="expertJobTitle">{jobTitle}</SearchSubtitle>}
      {description && (
        <SearchDescription data-testid="expertDescription">{description}</SearchDescription>
      )}
    </>
  );
};

export default ExpertInfo;

const SearchSubtitle = styled(Typography)`
  font-size: 18px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.common.gray};

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 20px;
  }
`;
const TitleWrapper = styled('div')`
  display: flex;
  align-items: center;
`;
const StyledFollowButton = styled(FollowButton)`
  position: relative;
  top: 2px;
  margin-left: 12px;
`;
